import { useEffect, useRef, useState } from "react";

const previews = {
  today: { label: "Heute", alt: "Heute in Performance Care: Tagesplan mit Training, Wohnungsreinigung und Recovery. Synthetische Beispieldaten." },
  services: { asset: "performance-care-app-showcase-services-v03.webp", label: "Services", alt: "Services in Performance Care: Reinigung, Physio, Handwerker, Transfer und Tischreservierung. Bestätigte Termine und Buchungen; der Handwerker ist in Planung. Synthetische Beispieldaten." },
  requests: { label: "Anfragen", alt: "Anfragen in Performance Care: Ein Care Manager organisiert einen Physiotermin und meldet sich persönlich zurück. Synthetische Beispieldaten." },
};

export default function LandingPhonePreview({ view = "today" }) {
  const [ready, setReady] = useState({});
  const [failed, setFailed] = useState({});
  const [displayed, setDisplayed] = useState(null);
  const mounted = useRef(false);

  useEffect(() => {
    mounted.current = true;
    return () => { mounted.current = false; };
  }, []);

  useEffect(() => {
    if (ready[view]) setDisplayed(view);
  }, [ready, view]);

  const prepareImage = async (image, key) => {
    try {
      if (image.decode) await image.decode();
    } catch {
      // Some browsers reject decode() even when the loaded image is usable.
      if (!image.naturalWidth) {
        if (mounted.current) setFailed((current) => ({ ...current, [key]: true }));
        return;
      }
    }
    if (mounted.current) setReady((current) => ({ ...current, [key]: true }));
  };

  const pending = displayed !== view && !failed[view];
  return (
    <div className="pc-landing-app__render" aria-busy={pending}>
      {/* Keep every image mounted and decoded; only opacity changes between views. */}
      {Object.entries(previews).map(([key, preview]) => (
        <img
          key={key}
          className="pc-landing-app__image"
          data-view={key}
          data-visible={displayed === key}
          src={`/landing-media/${preview.asset || `performance-care-app-showcase-${key}-v01.webp`}`}
          width="731"
          height="1537"
          alt={displayed === key ? preview.alt : ""}
          aria-hidden={displayed !== key}
          loading="eager"
          fetchPriority="low"
          decoding="async"
          draggable="false"
          onLoad={(event) => prepareImage(event.currentTarget, key)}
          onError={() => setFailed((current) => ({ ...current, [key]: true }))}
        />
      ))}
      <p className="pc-landing-app__image-status" role="status">
        {failed[view] ? `${previews[view].label}: Die App-Ansicht konnte nicht geladen werden.` : pending ? `${previews[view].label} wird geladen …` : ""}
      </p>
    </div>
  );
}
